import { useCallback, useEffect, useState } from "react";
import "./App.css";

function App() {
  const [inp, setInp] = useState("delhi");
  const [tmprtur, setTmprtur] = useState(null);
  const [wind, setWind] = useState(null);
  const [weather, setWeather] = useState(null);
  const [iconName, setIconName] = useState("50n");
  const WeatherICON = `https://openweathermap.org/img/wn/${iconName}@2x.png`

  const weekday = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
  const d = new Date();
  let day = weekday[d.getDay()];

  const weatherApiCall = useCallback(
    async function () {
      let res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${inp}&units=metric&APPID=${apiKey}`
      );
      let obj = await res.json();
      console.log(obj);
      setTmprtur(obj.main);
      setWeather(obj.weather[0]);
      setWind(obj.wind);
      setIconName(obj.weather[0].icon);
    },
    [inp]
  );

  const windDirect = function (deg) {
    let str = "";
    if (deg === 0) str = "West";
    else if (deg === 90) str = "North";
    else if (deg === 180) str = "East";
    else if (deg === 270) str = "South";
    else if (deg > 0 && deg < 90) str = "North West";
    else if (deg > 90 && deg < 180) str = "North East";
    else if (deg > 180 && deg < 270) str = "South East";
    else str = "South West";
    return str;
  };

  const apiKey = "c92a55312498bb6a688b34003f21d273";
  useEffect(() => {
    weatherApiCall();
  }, [
    weatherApiCall,
  ]);

  return (
    <div className="App  text-2xl flex justify-center flex-col items-center">
      <h1 className="text-7xl my-10">Weather App</h1>
      <label
        htmlFor="searchCity"
        className="bg-blue-300 flex justify-center items-center w-2/5 h-20 px-10 rounded-3xl"
      >
        Search City :- &nbsp;
        <input
          type="text"
          className="searchCity w-1/2 rounded-3xl text-center border-red-500 border"
          onChange={function (e) {
            setInp(e.target.value);
          }}
          value={inp}
        />
      </label>
      {!tmprtur ? (
        <p className="err my-5 bg-red-700 text-white w-2/5 h-96 flex justify-center items-center">
          Error...
          <br />
          Try again
        </p>
      ) : (
        <div className="containe my-5 flex flex-col rounded-3xl px-10 bg-blue-700 text-white w-2/5">
          <div className="flex justify-between  py-5">
            <div className="DateTime ">
              <div className="Date">
                {day +
                  " " +
                  (d.getMonth() + 1) +
                  "/" +
                  d.getDate() +
                  "/" +
                  d.getFullYear()}
              </div>
              <div className="Time text-center py-3">
                {d.getHours() + ":" + d.getMinutes()}
              </div>
            </div>
            <div className="TmprturIcon ">
              <div className="Icon rounded-full bg-blue-300">
                <img
                  src={WeatherICON}
                  alt={weather.main}
                />
              </div>
              <div className="iconTxt  text-center py-3">{weather.main}</div>
            </div>
          </div>

          <div className="Tmprtur ">
            <div className="text-5xl text-center">{tmprtur.temp} °C</div>
            <div className="MaxMinTmprtur flex justify-around my-4">
              <div className="max">Max : {tmprtur.temp_max} °C</div>
              <div className="min">Min : {tmprtur.temp_min} °C</div>
            </div>
            <div className="wind flex justify-around my-4">
              Wind : {windDirect(wind.deg)}
              <div className="windSpeed">Speed : {wind.speed}m/s</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;

//url for icons of Weathers => https://openweathermap.org/weather-conditions
//url forhttps://openweathermap.org/current